module.exports = __webpack_public_path__ + "static/media/loader.3a04aa2b.svg";